module.exports = __webpack_public_path__ + "images/icon_home_small.svg?aec97df393ae2af28f7b71105b685fba";